import type { GatsbyBrowser } from 'gatsby'
import { onRouteAnalytics, setupAnalyticsGlobals } from '@/common/analytics/bootstrap'
import { stripLanAbsoluteLinks } from '@/common/routing/internal_links'

export const disableCorePrefetching: GatsbyBrowser['disableCorePrefetching'] = () => true

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  setupAnalyticsGlobals()
  void loadLegacyRuntime()
  window.setTimeout(stripLanAbsoluteLinks, 100)
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  onRouteAnalytics(location.pathname)
  window.setTimeout(() => {
    window.PoptiraI18n?.applyI18n()
    window.dispatchEvent(new CustomEvent('poptira:locale-refresh'))
    const root = document.querySelector('[data-legacy-page-root]')
    if (root instanceof HTMLElement) {
      window.initLegacyPage?.(root)
    }
    stripLanAbsoluteLinks()
    window.setTimeout(stripLanAbsoluteLinks, 100)
  }, 0)
}

async function loadLegacyRuntime(): Promise<void> {
  await loadScript('/legacy/legacy.js')
  await loadScript('https://cdn.jsdelivr.net/npm/chart.js')
  await loadScript('https://cdn.jsdelivr.net/npm/alpinejs@3.x.x/dist/cdn.min.js', true)
  window.dispatchEvent(new CustomEvent('poptira:legacy-ready'))
}

function loadScript(src: string, defer = false): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = src
    if (defer) script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error(`failed to load ${src}`))
    document.body.appendChild(script)
  })
}